import React, { useRef } from 'react'
import {Icon, IconName} from "./Icon"
import './HideShowButton.less'

interface HideShowButtonProps {
  visible: boolean
  onChange: () => void
  tooltipTextVisible?: string
  tooltipTextHidden?: string
  className?: string
  iconName?: IconName
}

export const HideShowButton: React.FC<HideShowButtonProps> = ({
  visible,
  onChange,
  tooltipTextVisible = 'Hide',
  tooltipTextHidden = 'Show',
  className = '',
  iconName = visible ? IconName.Up : IconName.Down,
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onChange()
  }

  const tooltipText = visible ? tooltipTextVisible : tooltipTextHidden

  return (
    <div className={`hide-show-button-container ${className}`}>
      <button
        ref={buttonRef}
        className="hide-show-button"
        onMouseDown={handleClick}
        aria-label={tooltipText}
        aria-expanded={visible}
        title={tooltipText}
      >
        <Icon
          name={iconName}
          className="hide-show-icon"
          width="20"
          height="20"
        />
      </button>
    </div>
  )
}
